import { render, staticRenderFns } from "./PictureComp.vue?vue&type=template&id=0455c87e&scoped=true&"
import script from "./PictureComp.vue?vue&type=script&lang=ts&"
export * from "./PictureComp.vue?vue&type=script&lang=ts&"
import style0 from "./PictureComp.vue?vue&type=style&index=0&id=0455c87e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455c87e",
  null
  
)

export default component.exports